const parseBooleanOverride = (value: string | undefined): boolean | null => {
  if (value === "true") {
    return true;
  }

  if (value === "false") {
    return false;
  }

  return null;
};

export const COMPANY_QUESTION_TEMPLATES_FEATURE = {
  name: "company-question-templates",
  placeholderEnabled:
    parseBooleanOverride(
      process.env.NEXT_PUBLIC_COMPANY_QUESTION_TEMPLATES_ENABLED,
    ) ?? process.env.NODE_ENV !== "production",
} as const;

export function isCompanyQuestionTemplatesEnabled(): boolean {
  // TODO(dev): Replace this static placeholder with useFeatureIsOn once the
  // GrowthBook company-question-templates flag exists and generated types land.
  return COMPANY_QUESTION_TEMPLATES_FEATURE.placeholderEnabled;
}
